import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import type { AiCallDialogue } from '@/facilities/modules/aiCall';
import { useElapsed } from './liveUtils';
import './live.css';

export function LiveDot({ className }: { className?: string }) {
  return <span className={clsx('live-dot', className)} aria-hidden />;
}

/** "● LIVE 01:23" pill */
export function LiveBadge({
  since,
  className,
  showTime = true,
}: {
  since: AiCallDialogue['timestamp'] | null | undefined;
  className?: string;
  showTime?: boolean;
}) {
  const { t } = useTranslation();
  const elapsed = useElapsed(since, showTime);
  return (
    <span className={clsx('live-badge', className)} data-testid="live-badge">
      <LiveDot />
      {t('hotline_live').toUpperCase()}
      {showTime && <span className="live-badge__time">{elapsed}</span>}
    </span>
  );
}
